export default __webpack_public_path__ + "static/media/logo.94bad4dc.svg";